import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'MARKET_ADMIN_LOG_ALL',
        delete: 'MARKET_ADMIN_LOG_DELETE',
        sync: 'MARKET_ADMIN_LOG_SYNC'
      },
      permission: {
        query: '',
        add: 'market:admin:log:add',
        edit: 'market:admin:log:edit',
        detail: '',
        remove: 'market:admin:log:remove',
        sms_recharge: 'sms-recharge'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '100px'
      }, {
        prop: 'market_id',
        label: this.$t('market_id'),
        minWidth: '100px'
      }, {
        prop: 'admin_id',
        label: this.$t('admin_id'),
        minWidth: '100px'
      }, {
        prop: 'do_type',
        label: this.$t('do_type'),
        minWidth: '100px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "do_type",
              "value": row.do_type
            }
          });
        }
      }, {
        prop: 'do_device_uid',
        label: this.$t('do_device_uid'),
        minWidth: '100px'
      }, {
        prop: 'do_box_uid',
        label: this.$t('do_box_uid'),
        minWidth: '100px'
      }, {
        prop: 'do_device_name',
        label: this.$t('do_device_name'),
        minWidth: '100px'
      }, {
        prop: 'do_device_address',
        label: this.$t('do_device_address'),
        minWidth: '100px'
      }, {
        prop: 'do_box_name',
        label: this.$t('do_box_name'),
        minWidth: '100px'
      }, {
        prop: 'ctime',
        label: this.$t('ctime'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      } // { prop: 'uptime', label: 'uptime', minWidth: '100px', formatter: row => utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss') },
      ].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      return function (_ref2) {
        var row = _ref2.row;
        return [];
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this2 = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        label: this.$t('market_id'),
        default: utils.cookies.get('market_id'),
        show: false,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "model": {
              value: _this2.search.form.model.market_id,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "market_id", $$v);
              }
            }
          });
        } // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:140px;" custom clearable/>

      }, {
        prop: 'market_mobile',
        label: this.$t('market_mobile'),
        default: utils.cookies.get('phone'),
        show: false,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this2.search.form.model.market_mobile,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "market_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'admin_id',
        label: this.$t('admin_id'),
        default: this.admin_id,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this2.search.form.model.admin_id,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "admin_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this2.search.form.model.start_time,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this2.search.form.model.end_time,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    admin_id: function admin_id() {
      return this.$route.query.admin_id;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    goAdminData: function goAdminData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-courier-user';
      });
      this.$router.push({
        name: 'management-courier-user',
        query: {
          market_id: market_id
        }
      });
    },
    goDeviceData: function goDeviceData(market_mobile) {
      this.closeBy(function (page) {
        return page.name === 'management-device';
      });
      this.$router.push({
        name: 'management-device',
        query: {
          market_mobile: market_mobile
        }
      });
    },
    goChargeConfigsData: function goChargeConfigsData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-charge-configs';
      });
      this.$router.push({
        name: 'management-charge-configs',
        query: {
          market_id: market_id
        }
      });
    },
    goMarketServiceConfigData: function goMarketServiceConfigData(market_mobile) {
      this.closeBy(function (page) {
        return page.name === 'management-market-service-config';
      });
      this.$router.push({
        name: 'management-market-service-config',
        query: {
          market_mobile: market_mobile
        }
      });
    },
    goRechargeConfigData: function goRechargeConfigData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-recharge-config';
      });
      this.$router.push({
        name: 'management-wash-recharge-config',
        query: {
          market_id: market_id
        }
      });
    },
    goAppointTimeData: function goAppointTimeData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-appoint-time';
      });
      this.$router.push({
        name: 'management-wash-appoint-time',
        query: {
          market_id: market_id
        }
      });
    },
    goSmsRecharge: function goSmsRecharge(market_mobile) {
      this.closeBy(function (page) {
        return page.name === 'management-sms-recharge';
      });
      this.$router.push({
        name: 'management-sms-recharge',
        query: {
          market_mobile: market_mobile
        }
      });
    }
  })
};